import { render, staticRenderFns } from "./productosComponent.vue?vue&type=template&id=7564c372&"
import script from "./productosComponent.vue?vue&type=script&lang=js&"
export * from "./productosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports